import { CampaignType } from '@dev/ee-api/ee-api-models';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { push as Push } from 'redux-first-history';
import { Link } from '@material-ui/core';
import styled from 'styled-components';
import { Banner, SendingCampaign, SimpleLoader } from '@dev/ee-components';
import { CampaignsPaths } from '@/services/dictionaries/Paths';
import useMobile from '@/services/hooks/useMobile';

const BannerContainer = styled.div`
    margin: 32px 0;
`;

export const SendingCampaignBanner = (props: { name: string; type: CampaignType }): JSX.Element => {
    const { name, type } = props;
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const isMobile = useMobile();

    const bodyBanner = (
        <div>
            {t('viewthelivesendingprogress')}{' '}
            <Link
                onClick={(ev): void => {
                    ev.stopPropagation();
                    dispatch(
                        Push(CampaignsPaths.CampaignReportInProgress.replace(':type', type).replace(':name', name))
                    );
                }}
            >
                {t('here')}
            </Link>
        </div>
    );

    return (
        <BannerContainer>
            <Banner
                title={t('wearesendingyourcampaign')}
                body={bodyBanner}
                isInfo={false}
                icon={<SimpleLoader />}
                imageToDisplay={<SendingCampaign />}
                isMobile={isMobile}
            />
        </BannerContainer>
    );
};
